import React, {Component} from 'react';
import './app.css';
import Button from 'material-ui/Button';
import SearchIcon from 'material-ui-icons/Search';
import List, {ListItem, ListItemText, ListItemSecondaryAction} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import currentSongCard from './currentSongCard';
import IconButton from 'material-ui/IconButton'
import firebase from 'firebase';
import SpotifySearch from './SpotifySearch';
import BackArrowIcon from 'material-ui-icons/ArrowBack';
import PlusOneIcon from 'material-ui-icons/PlusOne'
import { Card, CardContent} from 'material-ui';

let database = firebase.database()

class Party extends Component {
  constructor(props) {
    super(props);

    let loggedInFeesieId = sessionStorage.getItem("feesieId");

    this.state = {
      searchShown: false,
      loggedInFeesieId: loggedInFeesieId,
      queueList: [],
      playingNow: {},
      feesieId: loggedInFeesieId
    };
    this.showSearch = this.showSearch.bind(this);
    this.hideSearch = this.hideSearch.bind(this);
    this.voteUpSong = this.voteUpSong.bind(this);

  }

  componentDidMount() {
    this.getAllFeesieData();
    this.getFeesieQueue();
    this.getFeesiePlaying();
  }

  getAllFeesieData() {
    let _this = this;
    let feesies = database.ref('feesies');
    let loggedInFeesieId = this.state.loggedInFeesieId;
    feesies.on('value', function(snapshot) {
      snapshot.forEach(feesie => {
        let feesieKey = feesie.key;
        if (feesieKey === loggedInFeesieId) {
          let feesieData = feesie.val();
          _this.setState({feesieData: feesieData});
        }
      })
    })
  }
  getFeesieQueue() {
    let _this = this;
    let feesieId = this.state.loggedInFeesieId;
    var feesieSongs = firebase.database().ref('/feesies/' + feesieId + '/feesie_songs/').orderByChild('votes');
    feesieSongs.on('value', function(snapshot) {
      let songQueueList = [];
      snapshot.forEach((queueSong) => {
        let queueItemValue = queueSong.val();
        let songQueueItem = {
          key: queueItemValue.key,
          id: queueItemValue.s_id,
          name: queueItemValue.name,
          artistName: queueItemValue.artistName,
          albumArtUrl: queueItemValue.albumArtUrl,
          votes: queueItemValue.votes
        }
        songQueueList.push(songQueueItem);
      });
      songQueueList.reverse();
      _this.setState({queueList: songQueueList});
    });
  }
  
// eslint-disable-next-line  
voteUpSong = queueItemVote => (e => {
    queueItemVote.votes++;
    let feesieId = this.state.feesieId;
    let queueItemVoteKey = queueItemVote.key;
    firebase.database().ref('feesies').child(feesieId).child('feesie_songs').child(queueItemVoteKey).set(queueItemVote);
  })

  getFeesiePlaying() {
    let _this = this;
    let feesieId = sessionStorage.getItem("feesieId");
    var feesieSongs = firebase.database().ref('/feesies/' + feesieId + '/feesie_playing/');
    feesieSongs.on('value', function(snapshot) {
      let queueItemValue = snapshot.val();
      if (queueItemValue) {
        let songQueueItem = {
          s_id: queueItemValue.s_id,
          name: queueItemValue.name,
          artistName: queueItemValue.artistName,
          albumArtUrl: queueItemValue.albumArtUrl
        }
        _this.setState({playingNow: songQueueItem});
        _this.createPlayingNowNotification();
      }
    });
  }

  createPlayingNowNotification() {
    let playingNow = this.state.playingNow;
    let notificationOptions = {
      tag: 'playingNowFeesie',
      icon: playingNow.albumArtUrl,
      body: playingNow.artistName,
      badge: '/images/icons/icon-96x96.png',
      lang: 'nl',
      requireInteraction: true
    };
    if (!("Notification" in window)) {
      console.log("This browser does not support desktop notification");
    } else if (Notification.permission === "granted") {
      navigator.serviceWorker.ready.then(function(registration) {
        registration.showNotification(playingNow.name, notificationOptions);
      });
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission(function(permission) {
        if (permission === "granted") {
          navigator.serviceWorker.ready.then(function(registration) {
            registration.showNotification(playingNow.name, notificationOptions);
          });
        }
      });
    }
  }

  hideSearch() {
    this.setState({searchShown: false});
  }

  showSearch() {
    this.setState({searchShown: true});
  }

  render() {

    if (!this.state.searchShown) {
      return (<div className="App">
        <div className="main-content">
          <Divider/>
          <div className="song-queue">
          <Card className="song-queue-card">
          <CardContent className="song-queue-card-content">

            <List>
              {
                this.state.queueList.map(queueItem => {
                  return <ListItem key={queueItem.key} className="song-queue-item" button={true}>
                    <img src={queueItem.albumArtUrl}></img>
                    <ListItemText primary={queueItem.name} secondary={queueItem.artistName}/>
                    <ListItemSecondaryAction>
                      <IconButton onClick={this.voteUpSong(queueItem)} className="vote-up-button" aria-label="vote-up">
                        <PlusOneIcon/>
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                })
              }
            </List>
            </CardContent>
            </Card>
          </div>
          <div className="current-song">
            <currentSongCard></currentSongCard>
          </div>
        </div>
        <div className="main-footer">
          <Button variant="fab" onClick={this.showSearch} color="white" className="search-fab" aria-label="search">
            <SearchIcon/>
          </Button>
        </div>
      </div>);
    } else {
      return <div className="App">
        <SpotifySearch></SpotifySearch>
        <Button fab="true" onClick={this.hideSearch} color="white" className="back-fab" aria-label="search">
          <BackArrowIcon/>
        </Button>
      </div>
    }
  }
}

export default Party;



// WEBPACK FOOTER //
// ./src/Party.js